import HcPassport  from "./HcPassport";

export default HcPassport;